import { handleBusinessError } from "../error-handler"

type AuthResponse<T> = Promise<{
	data?: T
	error?: {
		code?: string
		message?: string
	} | null
}>

export async function handleAuthCall<T>(promise: AuthResponse<T>): Promise<T> {
	const { data, error } = await promise
	if (error) {
		throw error
	}
	// handleBusinessError 处理完成，证明没有业务错误
	const passedData = handleBusinessError(data)
	return passedData as T
}
